import ReactJson from 'react-json-view';

interface JsonViewerProps {
  src: object;
  enableClipboard?: boolean;
  onEdit?: ((edit: { updated_src: object }) => void) | false;
  onAdd?: ((edit: { updated_src: object }) => void) | false;
  onDelete?: ((edit: { updated_src: object }) => void) | false;
  collapsed?: number;
}

/**
 * Reusable JSON viewer component with consistent styling
 * Used across the app for displaying JSON data in a formatted way
 */
export const JsonViewer = ({
  src,
  enableClipboard = true,
  onEdit = false,
  onAdd = false,
  onDelete = false,
  collapsed = 2,
}: JsonViewerProps) => {
  return (
    <div className="vai-flex-1 vai-min-h-0 vai-overflow-auto vai-bg-gray-50 vai-p-4 vai-rounded">
      <ReactJson
        src={src}
        theme="rjv-default"
        enableClipboard={
          enableClipboard
            ? (textToCopy) =>
                navigator.clipboard.writeText(
                  JSON.stringify(textToCopy.src, null, 2),
                )
            : false
        }
        onEdit={onEdit}
        onAdd={onAdd}
        onDelete={onDelete}
        displayDataTypes={false}
        displayObjectSize={false}
        collapsed={collapsed}
        style={{
          backgroundColor: 'transparent',
        }}
      />
    </div>
  );
};
